import { createContext } from "react";

export const errorAlertContextV2 = createContext<
  | ((
      error: unknown,
      title?: string,
      description?: string,
      buttonText?: string,
      onButtonPress?: () => void,
      showAdditionalHelp?: boolean,
    ) => void)
  | undefined
>(undefined);
